export const LOWEST_SAMPLE_RATE = 18000;
export const LOWER_SAMPLE_RATE = 22000;
export const LOW_SAMPLE_RATE = 26040;
export const MID_SAMPLE_RATE = 32500;
export const HIGH_SAMPLE_RATE = 44100;
